import { _patientUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';


const prescriptionUpload = createAsyncThunk('prescriptionUpload', async (formData:FormData) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = _patientUrls.prescriptionUpload
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default prescriptionUpload;
